import { Injectable } from '@angular/core';
import { Actions, Effect } from '@ngrx/effects';
import { ENV } from '../../environments/environment';
import { ENVIRONMENTS } from '../../environments/environments';
import * as fromAccount from '../../vas/business-objects/account/account.actions';
import { VasAppFacade } from '../../vas/services/vas-app-facade.service';
import * as fromNetwork from '../business-objects/network/network.actions';
import { systemEventTypes } from './system.actions';

@Injectable()
export class SystemSideEffects {

    @Effect({dispatch: false})
    debug$ = this.actions$
        .filter(() => ENV.name === ENVIRONMENTS.DEV)
        .do(action =>  console.debug('Action:', action.type, action.payload));

    /**
     * This effect will invoke the sync down process whenever the user changes
     * the active account
     */
    @Effect({dispatch: false})
    selectAccount$ = this.actions$
        .ofType(fromAccount.ACTIVE_CHANGED)
        .do((action: fromAccount.ActiveAccountChangedAction) =>
            this.appFacade.syncDown.sync(action.payload.to)
        );

    @Effect({dispatch: false})
    loggedOut$ = this.actions$
        .ofType(systemEventTypes.LoggedOutEvent)
        .do(() => {
            this.appFacade.objects.user.store.deActivate();
            this.appFacade.objects.config.store.setAuthToken(undefined);
            this.appFacade.objects.config.store.setRefreshToken(undefined);
            this.appFacade.objects.config.store.clearLastSyncDownDates();
            this.appFacade.store.dispatch(
                new fromNetwork.SetAuthenticated(false)
            );
        });

    constructor(
        protected actions$: Actions,
        protected appFacade: VasAppFacade
    ) {

    }
}



// WEBPACK FOOTER //
// ./src/core/system/system.side-effects.ts